module.exports = __webpack_public_path__ + "static/media/20200731-145727-002.a4f8714f.png";